module.exports = __webpack_public_path__ + "img/code@2x.2873bdf7.png";